/* eslint-disable */

import 'classlist.js';
import 'matchmedia-polyfill';
import 'intersection-observer';
import 'whatwg-fetch/fetch';
import '../src/util/polyfills/mouseEvent';
import '../src/util/polyfills/requestIdleCallback';
import smoothscroll from 'smoothscroll-polyfill';
import * as clipboard from 'clipboard-polyfill';

window.__clipboardPolyfill = clipboard;

/* eslint-enable */

smoothscroll.polyfill();
